import React, { useEffect, useRef, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Divider } from "antd";

// import HighchartsExporting from 'highcharts/modules/exporting';

// if (typeof Highcharts === 'object') {
//   HighchartsExporting(Highcharts);
// }

const ChartEnd = ({ data, endCall }) => {
  const chartRef = useRef();
  const [status, setStatus] = useState("");
  useEffect(() => {
    data.map(data => {
      setStatus(data.status);
    });
  }, [data]);

  let Score = [];
  let time = [];

  useEffect(() => {
    Score = [];
    time = [];
    data.map(data => {
      Score.push(parseFloat(data.score));

      if (endCall === true) {
        time.push(data.callStarted);
      }
    });
  }, [Score, time, endCall]);

  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "spline",
      backgroundColor: "transparent"
    },

    xAxis: {
      type: "datetime",
      visible: true,
      categories: time,
      lineWidth: 0,
      labels: {
        step: 10,
        format: "{text} s"
      }
    },
    yAxis: {
      visible: true,
      max: 1,
      min: 0,
      opposite: true,
      gridLineWidth: 0.8,
      tickAmount: 3,
      gridLineDashStyle: "longdash",
      title: {
        text: ""
      },
      tickPositioner: function() {
        return [0.2, 0.5, 0.8];
      },
      labels: {
        enabled: true,
        style: {
          fontSize: 18
        },
        formatter: function() {
          if (this.value == 0.8) {
            return "<b>VERIFIED</b>";
          } else if (this.value == 0.5) {
            return "<b>NOT SURE</b>";
          } else if (this.value == 0.2) {
            return "<b>SOMEONE ELSE</b>";
          }
        }
      }
    },
    credits: {
      enabled: false
    },
    tooltip: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        shadow: true,
        lineWidth: 2,
        animation: {
          duration: 3000
        },
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        }
      }
    },

    accessibility: {
      enabled: false
    },

    time: {
      useUTC: false
    },

    title: {
      text: " "
    },

    exporting: {
      enabled: false
    },

    series: [
      {
        data: null,
        zones: [
          {
            value: 0.1,
            color: "#ff0000"
          },
          {
            value: 0.2,
            color: "#dc0808"
          },
          {
            value: 0.3,
            color: "#c70a0a"
          },
          {
            value: 0.4,
            color: "#ae0909"
          },
          {
            value: 0.5,
            color: "#8b0a0a"
          },
          {
            value: 0.6,
            color: "#0a3f8b"
          },
          {
            value: 0.7,
            color: "#31d108"
          },
          {
            value: 0.8,
            color: "#09a10d"
          },
          {
            value: 0.9,
            color: "#07700a"
          },
          {
            value: 1,
            color: "#065a08"
          }
        ]
      }
    ]
  });

  useEffect(() => {
    setChartOptions({
      series: {
        data: Score
      }
    });
  }, []);

  return (
    <div>
      <Flex>
        <Box w="100%" h="50%">
          <HighchartsReact
            highcharts={Highcharts}
            options={chartOptions}
            constructorType="chart"
            ref={chartRef}
          />
        </Box>
      </Flex>
    </div>
  );
};

export default ChartEnd;
